export function LoadingScreen() {
  return (
    <div
      className="relative flex min-h-svh flex-col items-center justify-center gap-8 overflow-hidden"
      style={{ backgroundColor: "#0a0a0a" }}
    >
      {/* Top accent bar */}
      <div
        className="absolute top-0 left-0 right-0 h-[3px]"
        style={{ background: "linear-gradient(to right, #6B3FF2, #5A33D4, #6B3FF2)" }}
      />

      {/* Dot-grid pattern */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: "radial-gradient(circle, rgba(234,40,4,0.9) 1px, transparent 1px)",
          backgroundSize: "28px 28px",
        }}
      />

      {/* Radial glow */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background: "radial-gradient(ellipse 55% 45% at 50% 50%, rgba(234,40,4,0.07) 0%, transparent 70%)",
        }}
      />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center gap-6">
        {/* Wordmark */}
        <span
          style={{
            fontFamily: "'Geist', -apple-system, sans-serif",
            fontSize: "clamp(2rem, 5vw, 3.5rem)",
            fontWeight: 600,
            letterSpacing: "-0.05em",
            color: "#ffffff",
            lineHeight: 1,
          }}
        >
          Agent<span style={{ color: "#6B3FF2" }}>Framer</span>
        </span>

        {/* Divider */}
        <div
          className="w-16 h-px"
          style={{ background: "linear-gradient(to right, transparent, rgba(234,40,4,0.5), transparent)" }}
        />

        {/* Spinner + label */}
        <div className="flex items-center gap-3" role="status" aria-label="Loading">
          <span
            className="material-symbols-outlined animate-spin"
            aria-hidden="true"
            style={{ fontSize: "18px", color: "#6B3FF2" }}
          >
            progress_activity
          </span>
          <span
            className="text-[11px] font-medium tracking-wider"
            style={{ color: "rgba(255,255,255,0.5)" }}
          >
            Initializing
          </span>
        </div>
      </div>
    </div>
  );
}
